import React from 'react';

export interface JourneyInlineTableProps
  extends React.HTMLAttributes<HTMLDivElement> {
  ariaLive?: React.AriaAttributes['aria-live'];
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneyInlineTable: React.FC<JourneyInlineTableProps> = ({
  className,
  ariaLive = 'polite',
  children,
  ...props
}) => (
  <div
    {...props}
    className={cx('journey-inline-table', className)}
    aria-live={ariaLive}
  >
    {children}
  </div>
);

export const InlineEditableTable = JourneyInlineTable;

export default JourneyInlineTable;
